import type { Kitchen } from '@rta/rta-blueprint-library';

import { getIslandSuffix } from '../helpers/get-island-suffix';

export type OverheadIslandLettersProps = {
	kitchen: Kitchen;
	fontSize?: number;
};

const DEFAULT_FONT_SIZE = 6;

/**
 * Renders the alphabetical letter (A, B, C, ...) at each island's center on the
 * overhead layout page. Letters match the per-island page header prefix produced
 * by `getIslandPageTitle`. Only renders when there are 2+ islands.
 *
 * Coordinate system matches `showOverheadIslands`: islands are positioned at
 * `(island.center.x, island.center.z)` in the SVG.
 */
export const OverheadIslandLetters = (props: OverheadIslandLettersProps): React.ReactElement | null => {
	const { kitchen, fontSize = DEFAULT_FONT_SIZE } = props;
	const { islands } = kitchen.design;

	if (islands.children.length < 2) return null;

	return (
		<g pointerEvents="none">
			{islands.children.map((island) => {
				const letter = getIslandSuffix({ island, kitchen });
				if (!letter) return null;

				const { center } = island;

				return (
					<text
						key={island.id}
						x={center.x}
						y={center.z}
						fontSize={fontSize}
						fontFamily="Inter, sans-serif"
						fontWeight={700}
						fill="black"
						textAnchor="middle"
						dominantBaseline="central"
					>
						{letter}
					</text>
				);
			})}
		</g>
	);
};
